<div class="header-container">
  <app-header></app-header>
</div>
<div class="resultado-estudio">
  <div
    class="contenedor-resultado"
    [ngClass]="{ large: hasApprovalCertificate }"
  >
    <i
      class="fa fa-cog a-spin cargando-inicio"
      *ngIf="loading; else loaded"
    ></i>

    <ng-template #loaded>
      <div class="aprobado" *ngIf="canGoToSentToInformView">
        <h1>APROBACIÓN LEGAL</h1>
        <p>
          Las siguientes personas tienen pre-aprobación legal para abrir y
          operar productos en representación de la empresa
          <b>{{ study.businessName }}</b>, RUT <b>{{ study.rut }}</b>:
        </p>
        <ul class="pre-administradores">
          <li *ngFor="let administrator of study.administrators">
            {{ administrator.name }}, RUT {{ administrator.rut }}
          </li>
        </ul>

        <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>

        <app-button
          [loading]="sendingToInform"
          [text]="'Crear Informe'"
          [valid]="!sendingToInform"
          (onClick)="enviar()"
        >
        </app-button>
      </div>

      <div class="reprobado" *ngIf="isNotLegalApproved">
        <app-pdf-viewer [pdf]="this.study.certificate"></app-pdf-viewer>
        <div class="dispatch_buttons" *ngIf="hasDispatch">
          <label
            for="checkRequestStudy"
            style="color: #777; margin-bottom: 2rem; margin-top: 0.5rem"
          >
            <input
              type="checkbox"
              id="checkRequestStudy"
              [checked]="checkRequestStudy"
              (change)="handleCheckRequestStudy()"
              [disabled]="dispatching"
            />
            Informar esta sociedad vía revisión manual
          </label>
          <app-alert
            [alertType]="ALERT.DANGER"
            [alertMessage]="dispatchErrorMessage"
          >
          </app-alert>
          <app-button
            [loading]="dispatching"
            [text]="'Enviar a informar'"
            [valid]="checkRequestStudy && !dispatching"
            (onClick)="requestStudy()"
          >
          </app-button>
          <span class="footnote">
            *En caso de confirmar, la solicitud será enviada a abogados
            Legalbot.
          </span>
        </div>
      </div>
      
      <ng-template #content>
        <app-modal
          [lawyerName]="lawyerName"
          [nationalId]="study.rut"
        ></app-modal>
      </ng-template>
    </ng-template>
  </div>
</div>
